import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    margin: theme.spacing(1)
  },
  textfield: {
    margin: theme.spacing(1)
  },
  tab: {
    borderRadius: '10px 10px 0px 0px',
    marginRight: '2px',
    textTransform: 'none',
    fontSize: 12
  },
  button: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    backgroundColor: '#f9fbff',
    fontWeight: '500',
    textTransform: 'none',
    color: '#45464b'
  },
  title: {
    fontWeight: '800',
    paddingLeft: '15px',
    paddingRight: '20px',
    marginBottom: '0px',
    marginTop: '30px',
    color: '#f8984e'
  },
  subTitle: {
    fontWeight: '800',
    paddingLeft: '15px',
    paddingRight: '20px',
    marginBottom: '0px',
    marginTop: '30px',
    color: '#000'
  },
  mainTitle: {
    fontWeight: '800',
    fontSize: '1.37em',
    paddingLeft: '15px',
    paddingRight: '20px',
    marginBottom: '0px',
    marginTop: '0px',
    color: '#f8984e'
  },
  padded: {
    paddingTop: '20px'
  },
  deleteButton: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontWeight: '500',
    textTransform: 'none'
  },
  buttonGroupContainer: {
    marginRight: theme.spacing(1)
  },
  buttonGroup: {
    backgroundColor: '#f9fbff',
    fontWeight: '500',
    textTransform: 'none',
    color: '#45464b'
  },
  buttonGroupDelete: {
    backgroundColor: '#f9fbff',
    fontWeight: '500',
    textTransform: 'none'
  },
  dialogTitle: {
    fontSize: 14,
    fontWeight: '300'
  },
  linkSelectAll: {
    marginLeft: theme.spacing(2),
    fontWeight: '500',
    fontSize: '1.2em',
    textDecoration: 'underline'
  },
  linkClearAll: {
    fontWeight: '500',
    fontSize: '1.2em',
    textDecoration: 'underline'
  },
  linkSelectAllSmall: {
    marginLeft: theme.spacing(2),
    fontWeight: '500',
    fontSize: '0.9em',
    textDecoration: 'underline'
  },
  mainSelector: {
    width: '100%',
    textAlign: 'right',
    paddingRight: '25px',
    marginBottom: '20px'
  },
  linkClearAllSmall: {
    fontWeight: '500',
    fontSize: '0.9em',
    textDecoration: 'underline'
  },
  '@global': {
    '.MuiTabs-root': {
      background: '#fff'
    },
    '.MuiTab-textColorPrimary': {
      background: '#eee',
      color: '#aaa',
      borderLeft: 'solid 1px',
      borderRight: 'solid 1px',
      borderTop: 'solid 1px',
      borderColor: '#DDDDDD',
      borderRightColor: '#DDDDDD',
      minWidth: 'unset',
      fontWeight: '300',
      fontSize: 16
    },
    '.MuiTab-textColorPrimary.Mui-selected': {
      background: '#fff',
      color: '#555',
      fontWeight: '300'
    },
    '.MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#555',
      '&:hover': {
        backgroundColor: '#DDDDDD'
      }
    },
    '.MuiCheckbox-root': {
      '&:hover': {
        backgroundColor: '#DDDDDD'
      }
    },
    '.MuiAppBar-root': {
      boxShadow: 'none'
    }
  }
}));

export default useStyles;
